<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="45"
        height="54"
        viewBox="0 0 45 54"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 47.6376H44.9995V0H0V47.6376Z"
            fill="white"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 47.6387H45V53.1921H0.000434084L0 47.6387Z"
            fill="#FF322E"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.3527 12.5352L2.78853 35.703H8.26523L13.403 19.3272L15.9782 27.5142H12.647L11.3167 32.1879H17.4481L18.5537 35.703H24.187L16.6236 12.5352H10.3527Z"
            fill="black"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M32.794 12.5352H24.931V35.703H30.3686V17.2088H32.5598C35.1021 17.2088 36.5497 18.4468 36.5497 20.6838C36.5497 22.8808 35.1021 24.1591 32.5598 24.1591H32.2077V28.8325H32.794C38.6619 28.8325 42.1044 25.8165 42.1044 20.6838C42.1044 15.4511 38.6619 12.5352 32.794 12.5352Z"
            fill="black"
        />
    </svg>
</template>

<script>
export default {
    name: 'ApNews'
};
</script>
